import { create } from "zustand";

const uuidFreeStore = create((set, get) => ({
  uuidFree: true,
  setUuidFree: (newValue) => {
    if (newValue == null) return;
    if ((!!newValue) === get().uuidFree) {
      return;
    }
    set(() => ({
      uuidFree: !!newValue
    }));
  }
}));

export default uuidFreeStore;
